import { useIsFetching, useIsMutating } from '@tanstack/react-query'

/** 어떤 query/mutation 이라도 진행 중이면 페이지 최상단에 얇은 progress bar.
 *  본문을 'Loading...' 텍스트로 덮지 않기 위한 indicator. */
export function GlobalLoadingBar() {
  const fetching = useIsFetching()
  const mutating = useIsMutating()
  if (fetching === 0 && mutating === 0) return null
  return <div className="global-loading-bar" aria-hidden />
}
